import React, { createElement } from 'react';
import type { TAppModalData, TDeleteModalProps } from 'src/types';
import { CreateEditSubLocation } from './components/CreateEditSubLocation';
import { BookingModal } from './components/BookingModal';
import { CreateEditNotice } from './components/CreateEditNotice';
import type { TCreateEditSubLocationModalProps } from './components/CreateEditSubLocation/types';
import type { TCreateEditBookingModalProps } from './components/BookingModal/types';
import type { TCreateEditNoticeProps } from './components/CreateEditNotice';
import { DeleteModal } from './components/BookingModal/components/DeleteModal';

type TModalProps = {
    modalData?: TAppModalData;
};

export const Modals = (props: TModalProps) => {
    const { modalData } = props;
    return (
        <>
            {modalData?.name === 'CreateEditSubLocationModal' &&
                createElement(
                    CreateEditSubLocation,
                    modalData.options as TCreateEditSubLocationModalProps
                )}
            {modalData?.name === 'BookingModal' &&
                createElement(BookingModal, modalData.options as TCreateEditBookingModalProps)}

            {modalData?.name === 'CreateEditNotice' &&
                createElement(CreateEditNotice, modalData.options as TCreateEditNoticeProps)}

            {modalData?.name === 'DeleteBooking' &&
                createElement(DeleteModal, modalData.options as TDeleteModalProps)}
        </>
    );
};
